module.exports = __webpack_public_path__ + "img/logo_wittaya.72067807.jpg";